import {useParams} from "react-router-dom";
import styled from "styled-components";
import {useBaseCommunity, useRelativeTime} from '../../store';
import {WhiteMain} from '../../components/main';
import {FixedTopBar} from '../../components/top_bar';
import useFeedback from "../../utils/use_feedback";
import {useQuery} from "../../utils/router";
import {useLogs} from "../../api/communities";
import NavLink from "../../components/nav_link";
import {themecolors} from "../../utils/themecolors";
import Pagination from "../../components/pagination";

const TYPE_MAPPING = {
    approvepost: 'approved a post by',
    approvecomment: 'approved a comment by',
    removepost: 'removed a post by',
    removecomment: 'removed a comment by',
    ban: 'banned',
    unban: 'unbanned',
    removenote: 'removed a note on',
    addnote: 'added a note on',
    modpost: 'distinguished a post by',
    modcomment: 'distinguished a comment by',
    stickycomment: 'stickied a comment by',
    unstickycomment: 'unstickied a comment by',
    sticky: 'stickied a post by',
    unsticky: 'unstickied a post by',
    lockpost: 'locked a post by',
    unlockpost: 'unlocked a post by',
    ignoreposts: 'ignored reports on a post by',
    unignoreposts: 'unignored reports on post by',
    ignorecomments: 'ignored reports on a comment by',
    unignorecomments: 'unignored reports on a comment by',
    sort: 'set the recommended sort on a post by',
    retrythumbs: 'requested a new preview for',
}

const Info = styled.div``;
const Author = styled.span``;
const Ago = styled.span``;
const Moderator = styled.div``;

const LogEntry = styled(({className, log}) => {
    const ago = useRelativeTime(log.created, false);
    return (
        <div className={className}>
            <Info>
                <Author>{log.moderator ? <NavLink href={`/u/${log.moderator}`} react_route>{log.moderator}</NavLink> : 'A moderator'}</Author>
                <Ago>{ago} ago</Ago>
            </Info>
            <Moderator>{TYPE_MAPPING[log.type]} <NavLink href={`/u/${log.target}`} react_route>{log.target}</NavLink></Moderator>
        </div>
    )
})`
  padding: 16px 24px;

  ${Info} {
    display: flex;
    align-items: center;
  }

  ${Author} {
    font-weight: 600;
    font-size: 15px;
  }
  
  ${Moderator} {
    font-size: 14px;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_medium_impact_text};
  }

  ${Ago} {
    font-size: 13px;
    margin-left: auto;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_low_impact_text};
  }
`;

const Logs = styled(({className}) => {
    const {error, feedbackCh} = useFeedback();
    const baseCommunity = useBaseCommunity();
    const {community: paramsCommunity} = useParams();
    const community = (paramsCommunity || baseCommunity).toLowerCase();
    const {type = "", moderator = ""} = useQuery();
    const page = parseInt(useQuery().page || '1');
    const logs = useLogs(feedbackCh, community, page, type, moderator);
    return (
        <>
            <FixedTopBar back title={'Moderation Logs'} />
            <WhiteMain className={className}>
                {error && error.toString()}
                    {logs && logs.map((log) => (
                        <>
                            <LogEntry log={log} key={log.id} />
                        </>
                    ))}
                {logs && logs.length > 0 &&
                    <Pagination path={`?page=`} has_more page={page}/>
                }
            </WhiteMain>
        </>
    );
})`
`;

export default Logs;
